import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { MaxDimensionRuleComponent } from './MaxDimensionRuleComponent';
import { MAX_ATTACHMENT_SIZE } from './maxAttachmentSize';

const configValidator = yup
  .object({
    // Dimensione massima del file in MB
    value: yup
      .number()
      .positive()
      .max(
        MAX_ATTACHMENT_SIZE,
        `La dimensione massima deve essere uguale o inferiore a ${MAX_ATTACHMENT_SIZE} MB`,
      )
      .transform((value: number | null | undefined) =>
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        value == null ? MAX_ATTACHMENT_SIZE : value,
      )
      .default(MAX_ATTACHMENT_SIZE)
      .notRequired()
      .label('Dimensione Massima'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown()
  .nullable();

export const MaxDimensionRule: IRuleType<
  yup.InferType<typeof configValidator>
> = {
  type: RuleType.MaxDimension,
  name: 'Dimensione Massima',
  configComponent: MaxDimensionRuleComponent,
  configValidator: configValidator,
  validator: schema => schema,
};
